export function integrationsAdministrationPage() {
  return "/administration/integrations";
}

export function newNvmDeviceProfilePage() {
  return "/devices/profiles/nvm/new";
}
